import markets from "../../lib/markets";
import useWindowDimensions from "../../utils/width";

const InstrumentAnalytics = ({ trades, runSpeficCal, theme, showGross = false }) => {
  const win = "#26a65d";
  const loss = "#f23645";
  const breakeven = "#ED9E0E";

  const { width } = useWindowDimensions();
  const isDark = theme[0] === "dark";

  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "12px",
        width: "100%",
        maxWidth: "770px",
        backgroundColor: isDark ? "#1e1f23" : "#ffffff",
        border: `1px solid ${isDark ? "#2d2e33" : "#e5e7eb"}`,
        marginTop: "16px",
      }}
    >
      <div
        style={{
          fontSize: width <= 700 ? "16px" : "18px",
          fontWeight: "600",
          color: isDark ? "#e5e7eb" : "#374151",
          marginBottom: "16px",
        }}
      >
        Instrument Analytics
      </div>
      <table
        className={
          theme[0] === "dark" ? "tableHoverEffectDark" : "tableHoverEffectLight"
        }
        style={{
          tableLayout: "fixed",
          borderCollapse: "collapse",
          width: "100%",
          height: "200px",
          fontSize: width <= 700 ? "13px" : "14px",
          margin: "0 auto",
        }}
      >
        <thead
          className="tableHoverEffectOff"
          style={{ fontSize: width <= 700 ? "13px" : "16px", height: "50px" }}
        >
          <tr
            style={{
              position: "sticky",
              top: "0",
              backdropFilter: "blur(10px)",
            }}
          >
            <th
              style={{
                fontWeight: "400",
                textAlign: "left",
                paddingLeft: "5px",
              }}
            >
              Instrument
            </th>
            <th style={{ fontWeight: "400", color: win }}>Win</th>
            <th style={{ fontWeight: "400", color: breakeven }}>BE</th>
            <th style={{ fontWeight: "400", color: loss }}>Loss</th>
            <th style={{ fontWeight: "400" }}># Trades</th>
            <th style={{ fontWeight: "400" }}>Return %</th>
          </tr>
        </thead>
        <tbody>
          {markets.map((t, i) => {
            if (!t.ticker || i === 0) {
              return null;
            } else {
              return (
                <tr
                  key={i}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <th
                    style={{
                      fontWeight: "400",
                      textAlign: "left",
                      paddingLeft: "5px",
                    }}
                    scope="row"
                  >
                    {t.ticker}
                  </th>

                  <td style={{ color: win }}>
                    {
                      trades.filter(
                        (p) =>
                          p.pair === t.ticker &&
                          (p.outcomePC === "Win" || p.outcomeIC === "Win"),
                      ).length
                    }
                  </td>
                  <td style={{ color: breakeven }}>
                    {
                      trades.filter(
                        (p) =>
                          p.pair === t.ticker &&
                          (p.outcomePC === "Breakeven" ||
                            p.outcomeIC === "Breakeven"),
                      ).length
                    }
                  </td>
                  <td style={{ color: loss }}>
                    {
                      trades.filter(
                        (p) =>
                          p.pair === t.ticker &&
                          (p.outcomePC === "Loss" || p.outcomeIC === "Loss"),
                      ).length
                    }
                  </td>
                  <td> {trades.filter((p) => p.pair === t.ticker).length}</td>

                  {runSpeficCal(trades.filter((p) => p.pair === t.ticker), false, showGross)}
                </tr>
              );
            }
          })}
          <tr style={{ textAlign: "center" }}>
            <th
              style={{
                fontWeight: "400",
                textAlign: "left",
                paddingLeft: "5px",
              }}
              scope="row"
            >
              Total
            </th>
            <td style={{ color: win }}>
              {
                trades.filter(
                  (p) => p.outcomePC === "Win" || p.outcomeIC === "Win",
                ).length
              }
            </td>
            <td style={{ color: breakeven }}>
              {
                trades.filter(
                  (p) =>
                    p.outcomePC === "Breakeven" || p.outcomeIC === "Breakeven",
                ).length
              }
            </td>
            <td style={{ color: loss }}>
              {
                trades.filter(
                  (p) =>
                    p.outcomePC === "Loss" ||
                    p.outcomeIC === "Loss" 
                ).length
              }
            </td>
            <td>{trades.length}</td>

            {runSpeficCal(trades, false, showGross)}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default InstrumentAnalytics;
